// // Industries sub-pages

// const industryData = {
//   "industry-utility": {
//     icon: "⚡",
//     title: "Utility",
//     tagline: "Powering the digital transformation of electricity, gas, and water utilities.",
//     color: "#f7971e",
//     desc: "At Inovaantage, we empower utility companies to embrace digital transformation, operational efficiency, and sustainable growth. Our expertise spans energy management, smart metering, field workforce optimization, network monitoring, cybersecurity, and advanced analytics, providing end-to-end solutions tailored for the utility sector.",
//     challenges: [
//       { icon: "🗺️", title: "Aging GIS Infrastructure", desc: "Legacy GIS platforms that no longer support modern network operations, regulatory reporting, or safety-critical workflows." },
//       { icon: "⚡", title: "Grid Modernisation", desc: "Integrating distributed energy resources, smart meters, and EV charging while maintaining grid stability and safety." },
//       { icon: "📋", title: "Regulatory Compliance", desc: "Meeting increasingly demanding network performance, safety, and asset reporting obligations." },
//       { icon: "🔧", title: "Asset Data Quality", desc: "Incomplete, inaccurate, or fragmented asset records that undermine operational efficiency and investment planning." },
//     ],
//     solutions: [
//       {
//         id: 1,
//         icon: "🏠",
//         title: "Home Energy Management System (HEMS)",
//         subtitle: "Optimizing Customer Engagement and Energy Efficiency",
//         desc: "Inovaantage partnered with a leading Southeast Asian utility to design a next-generation Home Energy Management System (HEMS). Our work included:",
//         features: [
//           { title: "Customer Dashboards", desc: "Creating intuitive interfaces to give customers actionable insights into energy usage." },
//           { title: "Innovation Lab Setup", desc: "Establishing a demonstration lab to showcase HEMS capabilities and encourage further research." },
//           { title: "Reporting & Analytics", desc: "Developing mechanisms to track energy efficiency progress, supporting management decision-making." },
//         ],
//         impact: "Enhanced customer experience, encouraged sustainable energy adoption, and created a data-driven approach to energy management.",
//       },
//       {
//         id: 2,
//         icon: "🤝",
//         title: "Supplier Management System (SMS)",
//         subtitle: "Streamlining Supplier Operations for Utilities",
//         desc: "Inovaantage's Supplier Management System simplifies supplier oversight, enabling utility companies to manage procurement, performance, and compliance efficiently.",
//         features: [
//           { title: "Centralized Supplier Repository", desc: "Store contracts, performance data, and compliance records." },
//           { title: "Automated Procurement Workflows", desc: "Reduce manual effort in onboarding, contract management, and invoicing." },
//           { title: "Performance & Compliance Monitoring", desc: "Track supplier KPIs and regulatory adherence." },
//           { title: "Real-Time Analytics", desc: "Generate actionable insights for strategic supplier decisions." },
//         ],
//         impact: "Increased operational agility, improved supplier collaboration, and reduced procurement risks.",
//       },
//       {
//         id: 3,
//         icon: "💳",
//         title: "Smart Billing Solutions",
//         subtitle: "Accurate, Scalable, and Customer-Friendly Billing",
//         desc: "We helped a Southeast Asian utility with over 8 million customers transform its billing ecosystem.",
//         features: [
//           { title: "Automated Billing & Invoice Generation", desc: "" },
//           { title: "Customizable Billing Models", desc: "To suit diverse customer requirements." },
//           { title: "Real-Time Insights", desc: "For usage trends and revenue optimization." },
//           { title: "Scalable Infrastructure", desc: "To handle growing customer data." },
//           { title: "Enhanced Security & Compliance", desc: "" },
//         ],
//         impact: "Reduced operational overhead, minimized billing errors, and improved customer satisfaction through transparency and real-time insights.",
//       },
//       {
//         id: 4,
//         icon: "🌐",
//         title: "Network Management System – DialVaantage",
//         subtitle: "Ensuring Reliability Across Complex Utility Networks",
//         desc: "Our customized Network Management System, DialVaantage, addresses data loss and network inefficiencies in electrical distribution systems.",
//         features: [
//           { title: "Remote Meter Reading (RMR) Tracking", desc: "Detect failures and inconsistencies across multiple modules." },
//           { title: "SCADA & HMI Integration", desc: "Real-time monitoring and control for operational efficiency." },
//           { title: "Scalable Architecture", desc: "Designed to expand as client requirements grow." },
//           { title: "IoT Connectivity", desc: "LORA-based modems enhance network reliability and data accuracy." },
//         ],
//         impact: "Improved network uptime, reduced errors, and enhanced operational insights.",
//       },
//       {
//         id: 5,
//         icon: "🔐",
//         title: "Cybersecurity Solutions",
//         subtitle: "Protecting Utilities in a Digital Era",
//         desc: "Inovaantage safeguards critical utility operations with a comprehensive cybersecurity framework.",
//         features: [
//           { title: "Risk Assessment & Management", desc: "" },
//           { title: "Security Architecture Design & Implementation", desc: "" },
//           { title: "Threat Detection & Rapid Response", desc: "" },
//           { title: "Incident Recovery & Compliance Adherence", desc: "" },
//           { title: "Employee Training & Awareness Programs", desc: "" },
//         ],
//         impact: "Reduced risk of cyber threats, strengthened operational resilience, and ensured regulatory compliance.",
//       },
//       {
//         id: 6,
//         icon: "📟",
//         title: "Smart Meter Rollout & AMI Integration",
//         subtitle: "Streamlined Meter Management and Data Accuracy",
//         desc: "We implemented Siemens MDMS & Oracle ESB for a Southeast Asian utility.",
//         features: [
//           { title: "Integrated Meter Reading", desc: "Integration of manual and mobile meter reading systems." },
//           { title: "Centralized Meter Operations", desc: "Centralized meter operations and data repository." },
//           { title: "Full Service Support", desc: "Support for billing, energy accounting, demand response, and customer care." },
//         ],
//         impact: "Improved operational efficiency, accurate billing, and seamless integration with smart energy initiatives.",
//       },
//       {
//         id: 7,
//         icon: "👷",
//         title: "Field Force Management System – Fueerza",
//         subtitle: "Optimizing Workforce Operations for Utilities",
//         desc: "Fueerza enables utility companies to plan, monitor, and manage field operations.",
//         features: [
//           { title: "Task Scheduling & Dispatch", desc: "For field crews." },
//           { title: "Real-Time GPS Tracking", desc: "And mobile accessibility." },
//           { title: "Data Capture & Reporting", desc: "" },
//           { title: "Customizable Workflows", desc: "" },
//         ],
//         impact: "Enhanced productivity, better visibility of field operations, and improved service delivery.",
//       },
//       {
//         id: 8,
//         icon: "🗺️",
//         title: "GIS & Electrical Schematic Solutions",
//         subtitle: "Smart Asset Management and SLD Integration",
//         desc: "We provide GIS-integrated SLD and network management solutions.",
//         features: [
//           { title: "Legacy Migration", desc: "Migration from legacy ESRI systems to ArcGIS 10.x." },
//           { title: "Custom Schematic Modules", desc: "For electrical networks." },
//           { title: "iOS-Based Field Applications", desc: "And cloud-ready architecture." },
//           { title: "Cybersecurity & Active Directory Integration", desc: "" },
//         ],
//         impact: "Smarter decision-making, efficient asset management, and scalable GIS-enabled infrastructure.",
//       },
//       {
//         id: 9,
//         icon: "⚙️",
//         title: "Advanced Distribution Management System (ADMS)",
//         subtitle: "Seamless Upgrades & EMS Integration",
//         desc: "We assist utilities in upgrading to advanced DMS platforms.",
//         features: [
//           { title: "EMS Upgrade Blueprints", desc: "Detailed blueprints for EMS upgrades." },
//           { title: "Platform Migration", desc: "Smooth migration to PowerOn Advantage platforms." },
//           { title: "Scalable Database Architecture", desc: "Scalable, robust database architecture." },
//         ],
//         impact: "Reduced system downtime, future-ready infrastructure, and operational resilience.",
//       },
//       {
//         id: 10,
//         icon: "📉",
//         title: "Voltage Variation Optimization (VVO)",
//         subtitle: "Maximizing Efficiency and Reducing Losses",
//         desc: "Real-time network monitoring and modeling to optimize voltage levels and reduce losses.",
//         features: [
//           { title: "Real-Time Monitoring & Modeling", desc: "Using ETAP for network analysis." },
//           { title: "Voltage Optimization", desc: "Optimized voltage levels to prevent equipment damage." },
//           { title: "Conservation Voltage Reduction (CVR)", desc: "CVR recommendations for energy savings." },
//         ],
//         impact: "Reduced energy losses, improved voltage stability, and lower carbon footprint.",
//       },
//       {
//         id: 11,
//         icon: "💡",
//         title: "Idea Management – Caartera",
//         subtitle: "Turning Ideas into Action",
//         desc: "Our Caartera platform helps utility companies manage initiatives from concept to execution.",
//         features: [
//           { title: "Centralized Idea Tracking", desc: "And collaboration across teams." },
//           { title: "Agile Workflows & Benchmarking", desc: "" },
//           { title: "Transparent Communication", desc: "Across teams throughout the process." },
//         ],
//         impact: "Accelerated innovation, improved operational efficiency, and realization of untapped value from employee initiatives.",
//       },
//     ],
//     stats: [
//       { val: "50+", label: "Utility Clients Globally" },
//       { val: "50M+", label: "Assets Migrated" },
//       { val: "10+", label: "Countries" },
//       { val: "99.9%", label: "Data Accuracy Delivered" },
//     ],
//     clients: ["Ausgrid", "UK Power Networks", "ENMAX", "CLP Power", "Western Power Distribution", "SP Energy Networks"],
//   },

//   "industry-telecom": {
//     icon: "📡",
//     title: "Telecom",
//     tagline: "Enabling telecoms to build, manage, and monetise network infrastructure at scale.",
//     color: "#4facfe",
//     desc: "At Inovaantage, we empower telecom operators to modernize network operations, optimize asset management, and deliver exceptional customer experiences. Our solutions combine OSS/BSS, asset management, inventory control, and geographic information management with advanced analytics, automation, and cloud-ready technologies.",
//     challenges: [
//       { icon: "🌐", title: "Network Rollout Complexity", desc: "Managing the data, permits, and coordination for large-scale fibre and 5G infrastructure deployments." },
//       { icon: "🔌", title: "Duct & Conduit Management", desc: "Accurate underground infrastructure records to support build decisions, regulatory access, and maintenance." },
//       { icon: "📊", title: "Asset Lifecycle Management", desc: "End-to-end visibility of network assets from design through operations and decommissioning." },
//       { icon: "🔒", title: "Regulatory Reporting", desc: "Meeting Ofcom, ComReg, and equivalent regulatory reporting obligations with accurate spatial data." },
//     ],
//     solutions: [
//       {
//         id: 1,
//         icon: "🏗️",
//         title: "Property & Network Asset Management",
//         subtitle: "Optimizing Telecom Assets Across the Network Lifecycle",
//         desc: "Modern telecom networks are increasingly complex, spanning fibre, wireless, and data center infrastructure. Operators face challenges in tracking, maintaining, and optimizing these assets for performance and profitability.",
//         features: [
//           { title: "Centralized Asset Repository", desc: "Track network rollouts, site deployments, and infrastructure from acquisition to decommissioning." },
//           { title: "Workflow Automation", desc: "Automate maintenance schedules, approvals, and reporting to reduce cycle times and improve project delivery." },
//           { title: "Seamless IT Integration", desc: "Connect with existing IT and network systems to enable a unified view of assets and operations." },
//           { title: "Advanced Data Management", desc: "Manage bulk data effectively for faster insights, accurate reporting, and agile decision-making." },
//         ],
//         impact: "Increased operational efficiency, improved asset utilization, and accelerated project completion times.",
//       },
//       {
//         id: 2,
//         icon: "🔗",
//         title: "OSS/BSS Integration",
//         subtitle: "End-to-End Telecom Service Management",
//         desc: "Operators today require a unified OSS (Operations Support Systems) and BSS (Business Support Systems) platform to manage networks, services, and customer experience seamlessly.",
//         features: [
//           { title: "Visual Network Representation", desc: "Floor plans, rack elevations, shelf and slot views, physical ports, and installed SFPs." },
//           { title: "Intelligent Cable Management", desc: "Color-coded cable tracking for rapid identification and troubleshooting." },
//           { title: "Service Lifecycle Management", desc: "End-to-end visibility from service activation to maintenance, with real-time analytics." },
//           { title: "Automation & Analytics", desc: "Proactive alerts, performance monitoring, and predictive maintenance for minimal downtime." },
//         ],
//         impact: "Faster service delivery, reduced operational costs, and a reliable, automated platform for complex telecom operations.",
//       },
//       {
//         id: 3,
//         icon: "📦",
//         title: "AssetVaantage – Telecom Asset Management Platform",
//         subtitle: "Proactive Management for Modern Networks",
//         desc: "For large-scale fibre-to-home deployments and next-generation network services, effective asset management is critical. AssetVaantage, developed in-house by Inovaantage, ensures operators maintain network reliability while reducing operational risks.",
//         features: [
//           { title: "Comprehensive Asset Tracking", desc: "Monitor all assets, including fibre cables, network devices, and critical infrastructure." },
//           { title: "Proactive Maintenance", desc: "Schedule inspections, repairs, and replacements before issues impact service delivery." },
//           { title: "Emergency Preparedness", desc: "Real-time information enables rapid response to outages or faults." },
//           { title: "Scalable & Secure", desc: "Cloud-ready architecture ensures security, performance, and adaptability to growing networks." },
//         ],
//         impact: "Optimized network performance, improved service reliability, and proactive asset management for future growth.",
//       },
//       {
//         id: 4,
//         icon: "🗄️",
//         title: "Inventory Management System (IMS)",
//         subtitle: "Streamlined Telecom Inventory for Efficiency and Control",
//         desc: "Managing telecom inventory is challenging due to the sheer volume of network equipment, spare parts, and consumables. Inovaantage's IMS provides a digital solution to track, allocate, and manage inventory across multiple locations.",
//         features: [
//           { title: "Real-Time Stock Visibility", desc: "Track assets, spares, and components across warehouses and field locations." },
//           { title: "Automated Replenishment", desc: "Predict stock requirements and trigger replenishment orders automatically." },
//           { title: "Lifecycle Management", desc: "Monitor inventory from procurement to deployment to decommissioning." },
//           { title: "Analytics & Reporting", desc: "Gain insights into usage patterns, asset movement, and cost optimization." },
//         ],
//         impact: "Reduced stock-outs, lower operational costs, and enhanced planning for network expansion.",
//       },
//       {
//         id: 5,
//         icon: "🗺️",
//         title: "Geographic Information Management System (GIMS)",
//         subtitle: "Visualizing and Optimizing Network Assets Geographically",
//         desc: "For telecom operators, understanding network infrastructure in a spatial context is crucial for planning, maintenance, and expansion. GIMS integrates GIS capabilities with asset and network data to provide actionable insights.",
//         features: [
//           { title: "Interactive Network Maps", desc: "Visualize fibre, wireless, and electrical assets on interactive maps." },
//           { title: "Location-Based Planning", desc: "Optimize deployments, repairs, and resource allocation using spatial intelligence." },
//           { title: "Integration with OSS/BSS and AssetVaantage", desc: "Connect geographic insights with operational workflows for end-to-end management." },
//           { title: "Real-Time Updates", desc: "Track field operations and network changes dynamically across locations." },
//         ],
//         impact: "Enhanced decision-making, faster incident response, and strategic network expansion planning.",
//       },
//     ],
//     whyChooseUs: [
//       { icon: "🔗", title: "Integrated Solutions", desc: "OSS, BSS, Asset Management, IMS, and GIMS on a unified platform." },
//       { icon: "🤖", title: "Automation & Analytics", desc: "Reduce manual errors, optimize processes, and make informed decisions." },
//       { icon: "🚀", title: "Future-Ready", desc: "Supports fibre, wireless, and next-gen 5G networks." },
//       { icon: "🔒", title: "Scalable & Secure", desc: "Designed to grow with your network and business needs." },
//     ],
//     stats: [
//       { val: "10+", label: "Telecom Operators Served" },
//       { val: "100K+", label: "km of Network Mapped" },
//       { val: "5", label: "Countries with Active Programmes" },
//       { val: "40%", label: "Faster Build Decision Making" },
//     ],
//     clients: ["BT Openreach", "Eircom", "Chorus NZ", "Telkom Indonesia"],
//   },

//   "industry-infrastructure": {
//     icon: "🏗️",
//     title: "Infrastructure",
//     tagline: "Digital foundations for the infrastructure that powers modern economies.",
//     color: "#00b8a0",
//     desc: "Inovaantage supports infrastructure operators — including transport, water, and public utility networks — with the geospatial intelligence, data management, and technology solutions they need to operate safely, compliantly, and efficiently.",
//     challenges: [
//       { icon: "🗄️", title: "Complex Asset Portfolios", desc: "Diverse, geographically dispersed asset bases with inconsistent data quality and legacy records." },
//       { icon: "🔄", title: "Multi-System Integration", desc: "Connecting asset management, field operations, finance, and regulatory systems into a coherent data ecosystem." },
//       { icon: "📍", title: "Spatial Data Gaps", desc: "Incomplete or inaccurate spatial records that increase operational risk and undermine planning decisions." },
//       { icon: "🌱", title: "Sustainability Reporting", desc: "Increasing pressure to report on environmental, social, and governance metrics across infrastructure portfolios." },
//     ],
//     solutions: [
//       { id: 1, icon: "🗂️", title: "Asset Data Management", subtitle: "", desc: "", features: [], impact: "" },
//       { id: 2, icon: "📊", title: "Spatial Analytics & Reporting", subtitle: "", desc: "", features: [], impact: "" },
//       { id: 3, icon: "🖥️", title: "GIS Platform Implementation", subtitle: "", desc: "", features: [], impact: "" },
//       { id: 4, icon: "📱", title: "Field Data Capture", subtitle: "", desc: "", features: [], impact: "" },
//       { id: 5, icon: "🔧", title: "Custom Integration Development", subtitle: "", desc: "", features: [], impact: "" },
//       { id: 6, icon: "🛠️", title: "Managed Services", subtitle: "", desc: "", features: [], impact: "" },
//     ],
//     stats: [
//       { val: "20+", label: "Infrastructure Clients" },
//       { val: "1B+", label: "Assets Under Management" },
//       { val: "8", label: "Countries" },
//       { val: "30%", label: "Reduction in Asset Data Costs" },
//     ],
//     clients: ["National Grid", "Indra", "Melbourne Water", "Electricity North West"],
//   },
// };

// // ─── Stacked Row: used for both Challenges and Solutions ─────────────────────
// function StackedRow({ number, icon, title, subtitle, desc, features, impact, color }) {
//   return (
//     <div className="subpage-stack-row" style={{ "--accent": color }}>
//       {/* Left: number badge */}
//       <div className="subpage-stack-num" style={{ background: color }}>
//         {String(number).padStart(2, "0")}
//       </div>

//       {/* Icon */}
//       <div className="subpage-stack-icon">{icon}</div>

//       {/* Body */}
//       <div className="subpage-stack-body">
//         <h3 className="subpage-stack-title">{title}</h3>

//         {subtitle && (
//           <p className="subpage-stack-subtitle">{subtitle}</p>
//         )}

//         {desc && (
//           <p className="subpage-stack-desc">{desc}</p>
//         )}

//         {features && features.length > 0 && (
//           <ul className="subpage-stack-features">
//             {features.map((f, i) => (
//               <li key={i}>
//                 {f.title && <strong>{f.title}{f.desc ? ": " : ""}</strong>}
//                 {f.desc}
//               </li>
//             ))}
//           </ul>
//         )}

//         {impact && (
//           <div className="subpage-stack-impact" style={{ borderLeftColor: color }}>
//             <span className="subpage-stack-impact-label" style={{ color }}>💥 Impact: </span>
//             {impact}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default function IndustriesPage({ page }) {
//   const data = industryData[page];
//   if (!data) return null;

//   return (
//     <div className="subpage-root">

//       {/* ── Hero ── */}
//       <section className="subpage-hero" style={{ "--accent": data.color }}>
//         <div className="subpage-hero-badge">
//           <span className="subpage-icon">{data.icon}</span>
//           <span>Industries</span>
//         </div>
//         <h1 className="subpage-title">{data.title}</h1>
//         <p className="subpage-tagline">{data.tagline}</p>
//       </section>

//       {/* ── Overview ── */}
//       <section className="subpage-section">
//         <div className="subpage-container">
//           <div className="subpage-overview-card">
//             <h2>Our {data.title} Practice</h2>
//             <p>{data.desc}</p>
//           </div>
//         </div>
//       </section>

//       {/* ── Challenges — 1×1 stacked ── */}
//       <section className="subpage-section alt">
//         <div className="subpage-container">
//           <h2 className="subpage-section-title">Challenges We Solve</h2>
//           <div className="subpage-stack-list">
//             {data.challenges.map((c, i) => (
//               <StackedRow
//                 key={i}
//                 number={i + 1}
//                 icon={c.icon}
//                 title={c.title}
//                 subtitle={null}
//                 desc={c.desc}
//                 features={[]}
//                 impact={null}
//                 color={data.color}
//               />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── Solutions — 1×1 stacked ── */}
//       <section className="subpage-section">
//         <div className="subpage-container">
//           <h2 className="subpage-section-title">Solutions for {data.title}</h2>
//           <div className="subpage-stack-list">
//             {data.solutions.map((s, i) => (
//               <StackedRow
//                 key={i}
//                 number={s.id}
//                 icon={s.icon}
//                 title={s.title}
//                 subtitle={s.subtitle}
//                 desc={s.desc}
//                 features={s.features}
//                 impact={s.impact}
//                 color={data.color}
//               />
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── Why Choose Us — Telecom only ── */}
//       {data.whyChooseUs && (
//         <section className="subpage-section alt">
//           <div className="subpage-container">
//             <h2 className="subpage-section-title">Why Choose Inovaantage for {data.title}</h2>
//             <div className="subpage-stack-list">
//               {data.whyChooseUs.map((w, i) => (
//                 <StackedRow
//                   key={i}
//                   number={i + 1}
//                   icon={w.icon}
//                   title={w.title}
//                   subtitle={null}
//                   desc={w.desc}
//                   features={[]}
//                   impact={null}
//                   color={data.color}
//                 />
//               ))}
//             </div>
//           </div>
//         </section>
//       )}

//       {/* ── Impact & Clients ── */}
//       <section className={`subpage-section${data.whyChooseUs ? "" : " alt"}`}>
//         <div className="subpage-container">
//           <h2 className="subpage-section-title">Our Impact</h2>
//           <div className="subpage-outcomes-grid">
//             {data.stats.map((o, i) => (
//               <div key={i} className="subpage-outcome-card" style={{ "--accent": data.color }}>
//                 <span className="subpage-outcome-val">{o.val}</span>
//                 <span className="subpage-outcome-label">{o.label}</span>
//               </div>
//             ))}
//           </div>
//           <div style={{ marginTop: "2rem" }}>
//             <p className="subpage-section-subtitle">Clients Include</p>
//             <div className="subpage-clients">
//               {data.clients.map((c, i) => (
//                 <div key={i} className="subpage-client-badge">{c}</div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//     </div>
//   );
// }




// ═══════════════════════════════════════════════════════════════
// IndustriesPage.jsx — Premium Enterprise Redesign
// Inovaantage · GIS / Telecom / Utilities / Infrastructure
// Theme: White + Offwhite + Orange + Black | Deloitte / ESRI / Siemens aesthetic
// ═══════════════════════════════════════════════════════════════

import { useState, useEffect, useRef } from "react";
import './IndustriesPage.css';

// ── Responsive hook ──────────────────────────────────────────────
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= breakpoint);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [breakpoint]);
  return isMobile;
}

// ── Design tokens ────────────────────────────────────────────────
const T = {
  orange: "#E87722",
  orangeLight: "#F5A24B",
  orangePale: "#FFF4EB",
  orangeDeep: "#C4611A",
  black: "#0D0D0D",
  charcoal: "#1A1A1A",
  ink: "#2C2C2C",
  slate: "#4A4A4A",
  muted: "#6B6B6B",
  border: "#E8E4DF",
  borderLight: "#F0EDE9",
  offwhite: "#FAFAF8",
  white: "#FFFFFF",
  surface: "#F5F3F0",
  surfaceAlt: "#F0EDE9",
};

// ── Industry data (unchanged) ────────────────────────────────────
const industryData = {
  "industry-utility": {
    icon: "⚡",
    title: "Utility",
    tagline: "Powering the digital transformation of electricity, gas, and water utilities.",
    color: T.orange,
    desc: "At Inovaantage, we empower utility companies to embrace digital transformation, operational efficiency, and sustainable growth. Our expertise spans energy management, smart metering, field workforce optimization, network monitoring, cybersecurity, and advanced analytics, providing end-to-end solutions tailored for the utility sector.",
    challenges: [
      { icon: "🗺️", title: "Aging GIS Infrastructure", desc: "Legacy GIS platforms that no longer support modern network operations, regulatory reporting, or safety-critical workflows." },
      { icon: "⚡", title: "Grid Modernisation", desc: "Integrating distributed energy resources, smart meters, and EV charging while maintaining grid stability and safety." },
      { icon: "📋", title: "Regulatory Compliance", desc: "Meeting increasingly demanding network performance, safety, and asset reporting obligations." },
      { icon: "🔧", title: "Asset Data Quality", desc: "Incomplete, inaccurate, or fragmented asset records that undermine operational efficiency and investment planning." },
    ],
    solutions: [
      { id: 1, icon: "🏠", title: "Home Energy Management System (HEMS)", subtitle: "Optimizing Customer Engagement and Energy Efficiency", desc: "Inovaantage partnered with a leading Southeast Asian utility to design a next-generation Home Energy Management System (HEMS). Our work included:", features: [{ title: "Customer Dashboards", desc: "Creating intuitive interfaces to give customers actionable insights into energy usage." }, { title: "Innovation Lab Setup", desc: "Establishing a demonstration lab to showcase HEMS capabilities and encourage further research." }, { title: "Reporting & Analytics", desc: "Developing mechanisms to track energy efficiency progress, supporting management decision-making." }], impact: "Enhanced customer experience, encouraged sustainable energy adoption, and created a data-driven approach to energy management." },
      { id: 2, icon: "🤝", title: "Supplier Management System (SMS)", subtitle: "Streamlining Supplier Operations for Utilities", desc: "Inovaantage's Supplier Management System simplifies supplier oversight, enabling utility companies to manage procurement, performance, and compliance efficiently.", features: [{ title: "Centralized Supplier Repository", desc: "Store contracts, performance data, and compliance records." }, { title: "Automated Procurement Workflows", desc: "Reduce manual effort in onboarding, contract management, and invoicing." }, { title: "Performance & Compliance Monitoring", desc: "Track supplier KPIs and regulatory adherence." }, { title: "Real-Time Analytics", desc: "Generate actionable insights for strategic supplier decisions." }], impact: "Increased operational agility, improved supplier collaboration, and reduced procurement risks." },
      { id: 3, icon: "💳", title: "Smart Billing Solutions", subtitle: "Accurate, Scalable, and Customer-Friendly Billing", desc: "We helped a Southeast Asian utility with over 8 million customers transform its billing ecosystem.", features: [{ title: "Automated Billing & Invoice Generation", desc: "" }, { title: "Customizable Billing Models", desc: "To suit diverse customer requirements." }, { title: "Real-Time Insights", desc: "For usage trends and revenue optimization." }, { title: "Scalable Infrastructure", desc: "To handle growing customer data." }, { title: "Enhanced Security & Compliance", desc: "" }], impact: "Reduced operational overhead, minimized billing errors, and improved customer satisfaction through transparency and real-time insights." },
      { id: 4, icon: "🌐", title: "Network Management System – DialVaantage", subtitle: "Ensuring Reliability Across Complex Utility Networks", desc: "Our customized Network Management System, DialVaantage, addresses data loss and network inefficiencies in electrical distribution systems.", features: [{ title: "Remote Meter Reading (RMR) Tracking", desc: "Detect failures and inconsistencies across multiple modules." }, { title: "SCADA & HMI Integration", desc: "Real-time monitoring and control for operational efficiency." }, { title: "Scalable Architecture", desc: "Designed to expand as client requirements grow." }, { title: "IoT Connectivity", desc: "LORA-based modems enhance network reliability and data accuracy." }], impact: "Improved network uptime, reduced errors, and enhanced operational insights." },
      { id: 5, icon: "🔐", title: "Cybersecurity Solutions", subtitle: "Protecting Utilities in a Digital Era", desc: "Inovaantage safeguards critical utility operations with a comprehensive cybersecurity framework.", features: [{ title: "Risk Assessment & Management", desc: "" }, { title: "Security Architecture Design & Implementation", desc: "" }, { title: "Threat Detection & Rapid Response", desc: "" }, { title: "Incident Recovery & Compliance Adherence", desc: "" }, { title: "Employee Training & Awareness Programs", desc: "" }], impact: "Reduced risk of cyber threats, strengthened operational resilience, and ensured regulatory compliance." },
      { id: 6, icon: "📟", title: "Smart Meter Rollout & AMI Integration", subtitle: "Streamlined Meter Management and Data Accuracy", desc: "We implemented Siemens MDMS & Oracle ESB for a Southeast Asian utility.", features: [{ title: "Integrated Meter Reading", desc: "Integration of manual and mobile meter reading systems." }, { title: "Centralized Meter Operations", desc: "Centralized meter operations and data repository." }, { title: "Full Service Support", desc: "Support for billing, energy accounting, demand response, and customer care." }], impact: "Improved operational efficiency, accurate billing, and seamless integration with smart energy initiatives." },
      { id: 7, icon: "👷", title: "Field Force Management System – Fueerza", subtitle: "Optimizing Workforce Operations for Utilities", desc: "Fueerza enables utility companies to plan, monitor, and manage field operations.", features: [{ title: "Task Scheduling & Dispatch", desc: "For field crews." }, { title: "Real-Time GPS Tracking", desc: "And mobile accessibility." }, { title: "Data Capture & Reporting", desc: "" }, { title: "Customizable Workflows", desc: "" }], impact: "Enhanced productivity, better visibility of field operations, and improved service delivery." },
      { id: 8, icon: "🗺️", title: "GIS & Electrical Schematic Solutions", subtitle: "Smart Asset Management and SLD Integration", desc: "We provide GIS-integrated SLD and network management solutions.", features: [{ title: "Legacy Migration", desc: "Migration from legacy ESRI systems to ArcGIS 10.x." }, { title: "Custom Schematic Modules", desc: "For electrical networks." }, { title: "iOS-Based Field Applications", desc: "And cloud-ready architecture." }, { title: "Cybersecurity & Active Directory Integration", desc: "" }], impact: "Smarter decision-making, efficient asset management, and scalable GIS-enabled infrastructure." },
      { id: 9, icon: "⚙️", title: "Advanced Distribution Management System (ADMS)", subtitle: "Seamless Upgrades & EMS Integration", desc: "We assist utilities in upgrading to advanced DMS platforms.", features: [{ title: "EMS Upgrade Blueprints", desc: "Detailed blueprints for EMS upgrades." }, { title: "Platform Migration", desc: "Smooth migration to PowerOn Advantage platforms." }, { title: "Scalable Database Architecture", desc: "Scalable, robust database architecture." }], impact: "Reduced system downtime, future-ready infrastructure, and operational resilience." },
      { id: 10, icon: "📉", title: "Voltage Variation Optimization (VVO)", subtitle: "Maximizing Efficiency and Reducing Losses", desc: "Real-time network monitoring and modeling to optimize voltage levels and reduce losses.", features: [{ title: "Real-Time Monitoring & Modeling", desc: "Using ETAP for network analysis." }, { title: "Voltage Optimization", desc: "Optimized voltage levels to prevent equipment damage." }, { title: "Conservation Voltage Reduction (CVR)", desc: "CVR recommendations for energy savings." }], impact: "Reduced energy losses, improved voltage stability, and lower carbon footprint." },
      { id: 11, icon: "💡", title: "Idea Management – Caartera", subtitle: "Turning Ideas into Action", desc: "Our Caartera platform helps utility companies manage initiatives from concept to execution.", features: [{ title: "Centralized Idea Tracking", desc: "And collaboration across teams." }, { title: "Agile Workflows & Benchmarking", desc: "" }, { title: "Transparent Communication", desc: "Across teams throughout the process." }], impact: "Accelerated innovation, improved operational efficiency, and realization of untapped value from employee initiatives." },
    ],
    stats: [
      { val: "50+", label: "Utility Clients Globally" },
      { val: "50M+", label: "Assets Migrated" },
      { val: "10+", label: "Countries" },
      { val: "99.9%", label: "Data Accuracy Delivered" },
    ],
    clients: ["Ausgrid", "UK Power Networks", "ENMAX", "CLP Power", "Western Power Distribution", "SP Energy Networks"],
  },

  "industry-telecom": {
    icon: "📡",
    title: "Telecom",
    tagline: "Enabling telecoms to build, manage, and monetise network infrastructure at scale.",
    color: T.orange,
    desc: "At Inovaantage, we empower telecom operators to modernize network operations, optimize asset management, and deliver exceptional customer experiences. Our solutions combine OSS/BSS, asset management, inventory control, and geographic information management with advanced analytics, automation, and cloud-ready technologies.",
    challenges: [
      { icon: "🌐", title: "Network Rollout Complexity", desc: "Managing the data, permits, and coordination for large-scale fibre and 5G infrastructure deployments." },
      { icon: "🔌", title: "Duct & Conduit Management", desc: "Accurate underground infrastructure records to support build decisions, regulatory access, and maintenance." },
      { icon: "📊", title: "Asset Lifecycle Management", desc: "End-to-end visibility of network assets from design through operations and decommissioning." },
      { icon: "🔒", title: "Regulatory Reporting", desc: "Meeting Ofcom, ComReg, and equivalent regulatory reporting obligations with accurate spatial data." },
    ],
    solutions: [
      { id: 1, icon: "🏗️", title: "Property & Network Asset Management", subtitle: "Optimizing Telecom Assets Across the Network Lifecycle", desc: "Modern telecom networks are increasingly complex, spanning fibre, wireless, and data center infrastructure. Operators face challenges in tracking, maintaining, and optimizing these assets for performance and profitability.", features: [{ title: "Centralized Asset Repository", desc: "Track network rollouts, site deployments, and infrastructure from acquisition to decommissioning." }, { title: "Workflow Automation", desc: "Automate maintenance schedules, approvals, and reporting to reduce cycle times and improve project delivery." }, { title: "Seamless IT Integration", desc: "Connect with existing IT and network systems to enable a unified view of assets and operations." }, { title: "Advanced Data Management", desc: "Manage bulk data effectively for faster insights, accurate reporting, and agile decision-making." }], impact: "Increased operational efficiency, improved asset utilization, and accelerated project completion times." },
      { id: 2, icon: "🔗", title: "OSS/BSS Integration", subtitle: "End-to-End Telecom Service Management", desc: "Operators today require a unified OSS and BSS platform to manage networks, services, and customer experience seamlessly.", features: [{ title: "Visual Network Representation", desc: "Floor plans, rack elevations, shelf and slot views, physical ports, and installed SFPs." }, { title: "Intelligent Cable Management", desc: "Color-coded cable tracking for rapid identification and troubleshooting." }, { title: "Service Lifecycle Management", desc: "End-to-end visibility from service activation to maintenance, with real-time analytics." }, { title: "Automation & Analytics", desc: "Proactive alerts, performance monitoring, and predictive maintenance for minimal downtime." }], impact: "Faster service delivery, reduced operational costs, and a reliable, automated platform for complex telecom operations." },
      { id: 3, icon: "📦", title: "AssetVaantage – Telecom Asset Management Platform", subtitle: "Proactive Management for Modern Networks", desc: "For large-scale fibre-to-home deployments and next-generation network services, effective asset management is critical. AssetVaantage, developed in-house by Inovaantage, ensures operators maintain network reliability while reducing operational risks.", features: [{ title: "Comprehensive Asset Tracking", desc: "Monitor all assets, including fibre cables, network devices, and critical infrastructure." }, { title: "Proactive Maintenance", desc: "Schedule inspections, repairs, and replacements before issues impact service delivery." }, { title: "Emergency Preparedness", desc: "Real-time information enables rapid response to outages or faults." }, { title: "Scalable & Secure", desc: "Cloud-ready architecture ensures security, performance, and adaptability to growing networks." }], impact: "Optimized network performance, improved service reliability, and proactive asset management for future growth." },
      { id: 4, icon: "🗄️", title: "Inventory Management System (IMS)", subtitle: "Streamlined Telecom Inventory for Efficiency and Control", desc: "Managing telecom inventory is challenging due to the sheer volume of network equipment, spare parts, and consumables. Inovaantage's IMS provides a digital solution to track, allocate, and manage inventory across multiple locations.", features: [{ title: "Real-Time Stock Visibility", desc: "Track assets, spares, and components across warehouses and field locations." }, { title: "Automated Replenishment", desc: "Predict stock requirements and trigger replenishment orders automatically." }, { title: "Lifecycle Management", desc: "Monitor inventory from procurement to deployment to decommissioning." }, { title: "Analytics & Reporting", desc: "Gain insights into usage patterns, asset movement, and cost optimization." }], impact: "Reduced stock-outs, lower operational costs, and enhanced planning for network expansion." },
      { id: 5, icon: "🗺️", title: "Geographic Information Management System (GIMS)", subtitle: "Visualizing and Optimizing Network Assets Geographically", desc: "For telecom operators, understanding network infrastructure in a spatial context is crucial for planning, maintenance, and expansion. GIMS integrates GIS capabilities with asset and network data to provide actionable insights.", features: [{ title: "Interactive Network Maps", desc: "Visualize fibre, wireless, and electrical assets on interactive maps." }, { title: "Location-Based Planning", desc: "Optimize deployments, repairs, and resource allocation using spatial intelligence." }, { title: "Integration with OSS/BSS and AssetVaantage", desc: "Connect geographic insights with operational workflows for end-to-end management." }, { title: "Real-Time Updates", desc: "Track field operations and network changes dynamically across locations." }], impact: "Enhanced decision-making, faster incident response, and strategic network expansion planning." },
    ],
    whyChooseUs: [
      { icon: "🔗", title: "Integrated Solutions", desc: "OSS, BSS, Asset Management, IMS, and GIMS on a unified platform." },
      { icon: "🤖", title: "Automation & Analytics", desc: "Reduce manual errors, optimize processes, and make informed decisions." },
      { icon: "🚀", title: "Future-Ready", desc: "Supports fibre, wireless, and next-gen 5G networks." },
      { icon: "🔒", title: "Scalable & Secure", desc: "Designed to grow with your network and business needs." },
    ],
    stats: [
      { val: "10+", label: "Telecom Operators Served" },
      { val: "100K+", label: "km of Network Mapped" },
      { val: "5", label: "Countries with Active Programmes" },
      { val: "40%", label: "Faster Build Decision Making" },
    ],
    clients: ["BT Openreach", "Eircom", "Chorus NZ", "Telkom Indonesia"],
  },

  "industry-infrastructure": {
    icon: "🏗️",
    title: "Infrastructure",
    tagline: "Transforming Infrastructure Through Location Intelligence.",
    color: T.orange,
    desc: "At Inovaantage, we leverage the power of Geographic Information Systems (GIS) to help utilities, telecommunications providers, government agencies, and infrastructure organizations plan, design, and manage assets with greater efficiency and confidence.",
    challenges: [
      { icon: "🗄️", title: "Disconnected Asset Data", desc: "Infrastructure data siloed across legacy GIS, EAM, and operational platforms — preventing a unified view of network health and blocking data-driven investment decisions." },
      { icon: "🔄", title: "Reactive Network Management", desc: "No mechanism to detect emerging risks before they escalate — leaving utilities exposed to costly unplanned outages and inefficient, break-fix maintenance cycles." },
      { icon: "📊", title: "Capacity & Demand Uncertainty", desc: "Planning teams lack spatial modelling tools to accurately forecast load growth, population shifts, and infrastructure requirements — leading to over- or under-investment." },
      { icon: "🌪️", title: "Environmental & Climate Risk Exposure", desc: "Organisations cannot systematically assess how weather events, vegetation growth, flood zones, or wildfires affect infrastructure reliability — leaving critical assets vulnerable at scale." },
      { icon: "📍", title: "Inefficient Site Selection", desc: "Ad hoc site evaluation that fails to integrate accessibility, environmental constraints, regulatory data, and demand density — increasing project risk and slowing approvals." },
    ],
    solutions: [
      {
        id: 1,
        icon: "🗺️",
        title: "Network Planning & Design",
        subtitle: "Future-Ready Network Strategy",
        desc: "We help utilities and telecom operators design resilient, future-ready networks by integrating demand analysis, capacity modelling, coverage assessment, and asset performance data in a unified geospatial environment — supporting expansion, modernisation, and digital transformation programmes.",
        features: [
          { title: "Demand & Coverage Modelling", desc: "Spatial analysis of load growth, population trends, and service coverage gaps to guide expansion decisions." },
          { title: "Network Modernisation Planning", desc: "Identifying upgrade priorities and optimal routing for infrastructure renewal programmes." },
          { title: "Capacity Forecasting", desc: "Predictive spatial modelling to proactively address capacity constraints and support sustainable growth." },
        ],
        impact: "Reduced planning cycle times, optimised capital investment, and accelerated deployment of critical network infrastructure.",
      },
      {
        id: 2,
        icon: "📍",
        title: "Site Selection & Feasibility Analysis",
        subtitle: "Data-Driven Location Intelligence",
        desc: "Using advanced spatial analytics, we identify optimal locations for new infrastructure investments by evaluating accessibility, environmental constraints, regulatory requirements, customer demand density, and long-term operational efficiency — turning complex multi-variable decisions into clear, evidence-based recommendations.",
        features: [
          { title: "Multi-Criteria Spatial Analysis", desc: "Evaluating candidate sites against environmental, regulatory, and commercial criteria simultaneously." },
          { title: "Feasibility & Risk Scoring", desc: "Quantifying site-level risk to enable confident, defensible investment decisions." },
          { title: "Regulatory Constraint Mapping", desc: "Integrating land use, zoning, and environmental data to ensure compliance from the earliest planning stage." },
        ],
        impact: "Faster site approvals, reduced project risk, and higher confidence in capital allocation for new infrastructure investments.",
      },
      {
        id: 3,
        icon: "🔥",
        title: "Transmission Hotspot Detection",
        subtitle: "Proactive Risk Identification Across the Network",
        desc: "Inovaantage's hotspot detection solution consolidates asset data, outage records, inspection results, environmental conditions, and operational monitoring into a unified geospatial view — automatically identifying locations with elevated risk before they develop into critical failures.",
        features: [
          { title: "Risk-Based Hotspot Identification", desc: "Detecting transmission locations with elevated risk based on asset condition, loading patterns, outage history, and vegetation proximity." },
          { title: "Network Criticality Analysis", desc: "Evaluating the operational significance of assets to prioritise interventions where grid reliability risk is greatest." },
          { title: "Environmental & Climate Risk Monitoring", desc: "Assessing flood zones, wildfire exposure, and extreme weather impact on network reliability." },
          { title: "Prioritised Maintenance Planning", desc: "Directing maintenance resources to the highest-risk locations, reducing unplanned outages and optimising spend." },
        ],
        impact: "Earlier identification of network vulnerabilities and a measurable shift from reactive to proactive asset management.",
      },
      {
        id: 4,
        icon: "🔗",
        title: "Asset Management Integration",
        subtitle: "Connected Intelligence Across the Asset Lifecycle",
        desc: "Our GIS solutions integrate seamlessly with enterprise asset management systems, providing planners and asset managers with accurate, real-time asset information to make data-driven investment decisions throughout the full asset lifecycle — from planning through to decommissioning.",
        features: [
          { title: "EAM & GIS Integration", desc: "Connecting spatial and operational data sources into a single source of truth for asset health and performance." },
          { title: "Asset Health Assessment", desc: "Identifying aging or deteriorating infrastructure that may contribute to future reliability issues." },
          { title: "Investment Prioritisation", desc: "Providing actionable insights to direct capital where it delivers the greatest operational and financial return." },
        ],
        impact: "Extended asset life, reduced capital waste, and a unified operational picture that supports confident long-range planning.",
      },
      {
        id: 5,
        icon: "📈",
        title: "Capacity and Demand Forecasting",
        subtitle: "Spatial Modelling for Sustainable Growth",
        desc: "We utilise spatial modelling and predictive analytics to assess future infrastructure requirements, helping organisations proactively address capacity challenges and plan for sustainable growth in a changing operational landscape.",
        features: [
          { title: "Growth Scenario Modelling", desc: "Building multiple demand scenarios to stress-test infrastructure plans against a range of population and load growth assumptions." },
          { title: "Capacity Gap Analysis", desc: "Identifying where and when existing infrastructure will be unable to meet projected demand." },
          { title: "Long-Range Investment Planning", desc: "Supporting strategic capital planning with evidence-based forecasts of future infrastructure requirements." },
          { title: "Renewable Energy Integration Planning", desc: "Assessing the spatial and network implications of integrating distributed energy resources, EV charging, and renewable generation." },
        ],
        impact: "Proactive capacity management, reduced risk of demand-supply mismatches, and improved confidence in long-range infrastructure investment decisions.",
      },
      {
        id: 6,
        icon: "🛡️",
        title: "Risk, Resilience Planning and Digital Twin",
        subtitle: "Real-Time Visibility and Operational Simulation",
        desc: "By combining geospatial data with operational and environmental information, we help organisations identify vulnerabilities, assess risks, and develop resilient infrastructure strategies. Inovaantage also supports the development of GIS-enabled digital twins that provide real-time visibility into infrastructure networks, enabling advanced planning, scenario simulation, and operational optimisation at scale.",
        features: [
          { title: "Vulnerability Identification", desc: "Mapping network weaknesses against operational, environmental, and asset-condition data to prioritise resilience investments." },
          { title: "Climate and Environmental Risk Assessment", desc: "Integrating flood zones, wildfire risk, and extreme weather data to quantify and mitigate infrastructure exposure." },
          { title: "GIS-Enabled Digital Twin Development", desc: "Building live geospatial representations that mirror real-world network conditions and performance." },
          { title: "Scenario Planning and Simulation", desc: "Testing infrastructure responses to growth, failure, and environmental scenarios before committing capital." },
          { title: "Smart City and Emergency Response Integration", desc: "Supporting urban development planning, transportation analysis, and emergency response through connected spatial intelligence." },
        ],
        impact: "Accelerated planning confidence, reduced investment risk, a stronger grid, and a platform for continuous operational optimisation.",
      },
    ],
    whyChooseUs: [
      { icon: "🧠", title: "Deep Domain Expertise", desc: "We combine GIS technology mastery with real-world industry knowledge across utilities, telecoms, and government — bridging the gap between strategic planning and operational execution." },
      { icon: "🔗", title: "End-to-End Integration", desc: "Our solutions integrate seamlessly with enterprise GIS platforms, asset management systems, outage management tools, inspection programmes, and operational data sources — creating a single source of truth for network health." },
      { icon: "📊", title: "Measurable Outcomes", desc: "We focus on delivering tangible results: improving planning accuracy, reducing project costs, accelerating deployment, enhancing operational efficiency, and strengthening regulatory compliance." },
      { icon: "🌍", title: "Proven Global Experience", desc: "With extensive experience supporting electric utilities, telecom operators, and government agencies worldwide, Inovaantage understands the unique challenges of managing complex infrastructure networks." },
    ],
    stats: [
      { val: "20+", label: "Infrastructure Clients" },
      { val: "1B+", label: "Assets Under Management" },
      { val: "8", label: "Countries" },
      { val: "30%", label: "Reduction in Asset Data Costs" },
    ],
    clients: ["National Grid", "Indra", "Melbourne Water", "Electricity North West"],
  },
};

// ── Animated counter hook ─────────────────────────────────────────
function useCountUp(target, duration = 1800, trigger = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!trigger) return;
    const num = parseFloat(target.replace(/[^0-9.]/g, ""));
    if (isNaN(num)) return;
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const prog = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - prog, 3);
      setCount(Math.floor(eased * num));
      if (prog < 1) requestAnimationFrame(step);
      else setCount(num);
    };
    requestAnimationFrame(step);
  }, [trigger]);
  return count;
}

// ── Stat card with animated counter ─────────────────────────────
function StatCard({ val, label, triggered }) {
  const prefix = val.match(/^[^0-9]*/)?.[0] ?? "";
  const suffix = val.match(/[^0-9.]+$/)?.[0] ?? "";
  const count = useCountUp(val, 1800, triggered);
  const display = isNaN(parseFloat(val.replace(/[^0-9.]/g, "")))
    ? val
    : `${prefix}${count.toLocaleString()}${suffix}`;

  return (
    <div style={styles.statCard}>
      <span style={styles.statVal}>{display}</span>
      <span style={styles.statLabel}>{label}</span>
    </div>
  );
}

// ── Intersection observer hook ───────────────────────────────────
function useInView(threshold = 0.2) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
}

// ── GIS abstract background SVG ──────────────────────────────────
function GisBackground({ opacity = 0.045 }) {
  return (
    <svg
      style={{ position: "absolute", inset: 0, width: "100%", height: "100%", pointerEvents: "none" }}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      <defs>
        <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse">
          <path d="M 60 0 L 0 0 0 60" fill="none" stroke={T.orange} strokeWidth="0.5" opacity={opacity * 10} />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)" />
      {/* Abstract network nodes */}
      {[
        [120, 80], [340, 160], [580, 60], [820, 140], [1100, 90],
        [200, 280], [460, 320], [700, 260], [950, 300],
        [80, 420], [310, 400], [560, 460], [800, 380], [1050, 440],
      ].map(([cx, cy], i) => (
        <g key={i}>
          <circle cx={cx} cy={cy} r="4" fill={T.orange} opacity={opacity * 4} />
          <circle cx={cx} cy={cy} r="12" fill="none" stroke={T.orange} strokeWidth="0.5" opacity={opacity * 3} />
        </g>
      ))}
      {/* Connecting lines */}
      {[
        "M120,80 L340,160", "M340,160 L580,60", "M580,60 L820,140", "M820,140 L1100,90",
        "M200,280 L460,320", "M460,320 L700,260", "M700,260 L950,300",
        "M120,80 L200,280", "M340,160 L460,320", "M580,60 L700,260",
        "M80,420 L310,400", "M310,400 L560,460", "M560,460 L800,380",
      ].map((d, i) => (
        <path key={i} d={d} fill="none" stroke={T.orange} strokeWidth="0.8" opacity={opacity * 3} strokeDasharray="4,8" />
      ))}
    </svg>
  );
}

// ── Section divider ──────────────────────────────────────────────
function Divider({ flipped = false }) {
  return (
    <div style={{ overflow: "hidden", lineHeight: 0, transform: flipped ? "rotate(180deg)" : "none" }}>
      <svg viewBox="0 0 1200 40" preserveAspectRatio="none" style={{ display: "block", width: "100%", height: 40 }}>
        <path d="M0,40 L0,0 Q300,40 600,20 Q900,0 1200,30 L1200,40 Z" fill={T.surface} />
      </svg>
    </div>
  );
}

// ── Challenge card ───────────────────────────────────────────────
function ChallengeCard({ icon, title, desc, index }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      style={{
        ...styles.challengeCard,
        transform: hovered ? "translateY(-4px)" : "translateY(0)",
        boxShadow: hovered
          ? "0 16px 48px rgba(232,119,34,0.12), 0 4px 16px rgba(0,0,0,0.06)"
          : "0 2px 12px rgba(0,0,0,0.04)",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{ ...styles.challengeIndex }}>{String(index + 1).padStart(2, "0")}</div>
      <div style={styles.challengeIconWrap}>
        <span style={{ fontSize: 22 }}>{icon}</span>
      </div>
      <h3 style={styles.challengeTitle}>{title}</h3>
      <p style={styles.challengeDesc}>{desc}</p>
      <div style={{ ...styles.challengeAccent, width: hovered ? "100%" : "32px" }} />
    </div>
  );
}

// ── Solution card (alternating layout) ──────────────────────────
function SolutionCard({ solution, index, color }) {
  const isMobile = useIsMobile(768);
  const isEven = index % 2 === 0;
  const [ref, inView] = useInView(0.15);
  const [hovered, setHovered] = useState(false);

  return (
    <div
      ref={ref}
      style={{
        ...styles.solutionRow,
        flexDirection: isMobile ? "column" : "row",
        opacity: inView ? 1 : 0,
        transform: inView ? "translateY(0)" : "translateY(32px)",
        transition: "opacity 0.55s ease, transform 0.55s ease",
        transitionDelay: `${(index % 3) * 0.08}s`,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Number column */}
      <div style={{
        ...styles.solutionNumCol,
        flexDirection: isMobile ? "row" : "column",
        alignItems: "center",
        width: isMobile ? "100%" : 52,
        marginBottom: isMobile ? 16 : 0,
      }}>
        <div style={{
          ...styles.solutionNumBadge,
          background: hovered
            ? `linear-gradient(135deg, ${T.orange}, ${T.orangeDeep})`
            : `linear-gradient(135deg, ${T.orangeLight}, ${T.orange})`,
        }}>
          {String(solution.id).padStart(2, "0")}
        </div>
        {!isMobile && <div style={styles.solutionNumLine} />}
      </div>

      {/* Content card */}
      <div style={{
        ...styles.solutionCard,
        marginLeft: isMobile ? 0 : 20,
        padding: isMobile ? "20px 16px" : "28px 32px",
        boxShadow: hovered
          ? "0 20px 60px rgba(232,119,34,0.1), 0 4px 20px rgba(0,0,0,0.06)"
          : "0 2px 16px rgba(0,0,0,0.04)",
      }}>
        {/* Header */}
        <div style={styles.solutionHeader}>
          <div style={{
            ...styles.solutionIconBox,
            background: hovered
              ? `linear-gradient(135deg, ${T.orange}, ${T.orangeDeep})`
              : `linear-gradient(135deg, ${T.orangeLight}, ${T.orange})`,
          }}>
            <span style={{ fontSize: 22 }}>{solution.icon}</span>
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <h3 style={{
              ...styles.solutionTitle,
              fontSize: isMobile ? 16 : 18,
              wordBreak: "break-word",
            }}>{solution.title}</h3>
            {solution.subtitle && (
              <p style={styles.solutionSubtitle}>{solution.subtitle}</p>
            )}
          </div>
        </div>

        {/* Body */}
        {solution.desc && (
          <p style={{ ...styles.solutionDesc, fontSize: isMobile ? 13 : 14 }}>
            {solution.desc}
          </p>
        )}

        {solution.features && solution.features.length > 0 && (
          <div style={{
            ...styles.featuresGrid,
            gridTemplateColumns: "1fr",
          }}>
            {solution.features.map((f, i) => (
              <div key={i} style={styles.featureItem}>
                <div style={styles.featureDot} />
                <div style={{ minWidth: 0, flex: 1 }}>
                  {f.title && <span style={styles.featureTitle}>{f.title}{f.desc ? " — " : ""}</span>}
                  {f.desc && <span style={{ ...styles.featureDesc, wordBreak: "break-word" }}>{f.desc}</span>}
                </div>
              </div>
            ))}
          </div>
        )}

        {solution.impact && (
          <div style={styles.impactBanner}>
            <span style={styles.impactLabel}>Impact</span>
            <p style={styles.impactText}>{solution.impact}</p>
          </div>
        )}
      </div>
    </div>
  );
}

// ── WhyChooseUs card ─────────────────────────────────────────────
function WhyCard({ icon, title, desc, index }) {
  const [hovered, setHovered] = useState(false);
  return (
    <div
      style={{
        ...styles.whyCard,
        transform: hovered ? "translateY(-6px)" : "translateY(0)",
        boxShadow: hovered
          ? `0 24px 60px rgba(232,119,34,0.14), 0 4px 20px rgba(0,0,0,0.06)`
          : "0 2px 12px rgba(0,0,0,0.04)",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={{
        ...styles.whyIconBox,
        background: hovered
          ? `linear-gradient(135deg, ${T.orange}, ${T.orangeDeep})`
          : `linear-gradient(135deg, ${T.orangePale}, #FFE8CC)`,
      }}>
        <span style={{ fontSize: 24, filter: hovered ? "brightness(10)" : "none", transition: "filter 0.3s" }}>{icon}</span>
      </div>
      <h3 style={styles.whyTitle}>{title}</h3>
      <p style={styles.whyDesc}>{desc}</p>
    </div>
  );
}

// ── Section heading component ────────────────────────────────────
function SectionHeading({ eyebrow, title, center = false }) {
  return (
    <div style={{ ...styles.sectionHeadingWrap, textAlign: center ? "center" : "left" }}>
      {eyebrow && <span style={styles.eyebrow}>{eyebrow}</span>}
      <h2 style={{ ...styles.sectionTitle, textAlign: center ? "center" : "left" }}>{title}</h2>
      <div style={{ ...styles.headingRule, margin: center ? "0 auto" : "0" }} />
    </div>
  );
}

// ── Main page component ──────────────────────────────────────────
export default function IndustriesPage({ page = "industry-utility", setActivePage }) {
  const isMobile = useIsMobile(768);
  // All hooks must be called unconditionally, before any early return
  const [statsRef, statsInView] = useInView(0.3);
  const [activeSection, setActiveSection] = useState("overview");

  const data = industryData[page];

  // navSections depends on data, but we still define it unconditionally
  // (falls back to base list when data is null so hook deps stay stable)
  const navSections = [
    { id: "overview", label: "Overview" },
    { id: "challenges", label: "Challenges" },
    { id: "solutions", label: "Solutions" },
    ...(data?.whyChooseUs ? [{ id: "why", label: "Why Us" }] : []),
    { id: "impact", label: "Impact" },
  ];

  useEffect(() => {
    const onScroll = () => {
      const sections = navSections.map(s => ({
        id: s.id,
        el: document.getElementById(`section-${s.id}`),
      }));
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = sections[i].el;
        if (el && el.getBoundingClientRect().top <= 140) {
          setActiveSection(sections[i].id);
          break;
        }
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Early return AFTER all hooks
  if (!data) return null;

  return (
    <div style={styles.root}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;1,9..40,300&display=swap');
        * { box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        ::selection { background: ${T.orange}33; color: ${T.charcoal}; }

        .challenge-accent {
          transition: width 0.35s ease;
        }

        @keyframes fadeSlideUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes heroFade {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulse {
          0%,100% { transform: scale(1); opacity: 1; }
          50%      { transform: scale(1.08); opacity: 0.85; }
        }
        .hero-badge { animation: fadeSlideUp 0.6s ease both; }
        .hero-h1    { animation: fadeSlideUp 0.6s ease 0.1s both; }
        .hero-tag   { animation: fadeSlideUp 0.6s ease 0.2s both; }
        .hero-desc  { animation: fadeSlideUp 0.6s ease 0.3s both; }

        @media (max-width: 900px) {
          .side-nav { display: none !important; }
          .solutions-inner { max-width: 100% !important; padding: 0 !important; }
        }
        @media (max-width: 768px) {
          .hero-h1 { font-size: clamp(1rem, 8vw, 3rem) !important; word-break: break-word !important; }
          .hero-tag { font-size: 14px !important; max-width: 100% !important; }
          .hero-desc { font-size: 14px !important; }
          .challenges-grid { grid-template-columns: 1fr !important; gap: 16px !important; }
          .why-grid { grid-template-columns: 1fr 1fr !important; gap: 16px !important; }
          .stats-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important; }
          .clients-wrap { flex-wrap: wrap !important; gap: 16px !important; justify-content: center !important; }
          .solutions-inner { max-width: 100% !important; }
        }
        @media (max-width: 640px) {
          .challenges-grid { grid-template-columns: 1fr !important; }
          .stats-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .why-grid { grid-template-columns: 1fr !important; }
          .clients-wrap { flex-wrap: wrap !important; }
        }
      `}</style>

      {/* ══ Floating side nav ══ */}
      <nav className="side-nav" style={styles.sideNav}>
        {navSections.map(s => (
          <a
            key={s.id}
            href={`#section-${s.id}`}
            style={{
              ...styles.sideNavItem,
              color: activeSection === s.id ? T.orange : T.muted,
              fontWeight: activeSection === s.id ? 600 : 400,
            }}
          >
            <span style={{
              ...styles.sideNavDot,
              background: activeSection === s.id ? T.orange : T.border,
              transform: activeSection === s.id ? "scale(1.4)" : "scale(1)",
            }} />
            {s.label}
          </a>
        ))}
      </nav>

      {/* ══ HERO ══ */}
      <section style={styles.hero}>
        <div style={{ position: "absolute", inset: 0, overflow: "hidden" }}>
          <GisBackground opacity={0.04} />
          {/* Gradient overlays */}
          <div style={{
            position: "absolute", inset: 0,
            background: `radial-gradient(ellipse at 70% 40%, ${T.orange}18 0%, transparent 60%)`,
          }} />
          <div style={{
            position: "absolute", bottom: 0, left: 0, right: 0, height: "40%",
            background: `linear-gradient(to top, ${T.white}, transparent)`,
          }} />
        </div>

        <div style={{
          ...styles.heroInner,
          padding: isMobile ? "88px 20px 56px" : "100px 64px 80px",
          maxWidth: isMobile ? "100%" : 820,
        }}>
          <div className="hero-badge" style={styles.heroBadge}>
            <span style={{ fontSize: 20, marginRight: 8 }}>{data.icon}</span>
            <span>Industries</span>
            <span style={styles.heroBadgeDivider} />
            <span style={{ color: T.orange }}>Inovaantage</span>
          </div>

          <h1 className="hero-h1" style={{
            ...styles.heroH1,
            fontSize: isMobile ? "clamp(2rem, 9vw, 3rem)" : "clamp(52px, 7vw, 3.5rem)",
            wordBreak: "break-word",
            overflowWrap: "break-word",
          }}>{data.title}</h1>

          <p className="hero-tag" style={{
            ...styles.heroTagline,
            fontSize: isMobile ? 14 : "clamp(16px, 2vw, 20px)",
            maxWidth: "100%",
          }}>{data.tagline}</p>

          <div className="hero-desc" style={{
            ...styles.heroDescLine,
            maxWidth: "100%",
          }}>
            <span style={styles.heroDescAccent} />
            <p style={styles.heroDesc}>{data.desc}</p>
          </div>
        </div>

        {/* Bottom fade */}
        <div style={{
          position: "absolute", bottom: 0, left: 0, right: 0, height: 80,
          background: `linear-gradient(to top, ${T.white}, transparent)`,
          pointerEvents: "none",
        }} />
      </section>

      {/* ══ OVERVIEW ══ */}
      <section id="section-overview" style={{ ...styles.section, background: T.white }}>
        <div style={{ ...styles.container, padding: isMobile ? "0 16px" : "0 40px" }}>
          <div style={{
            ...styles.overviewGrid,
            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
            gap: isMobile ? 32 : 80,
          }}>
            <div>
              <SectionHeading eyebrow="Our Practice" title={`${data.title} Expertise`} />
              <p style={styles.overviewDesc}>{data.desc}</p>
            </div>
            <div style={styles.overviewAccentBox}>
              <div style={styles.overviewAccentLine} />
              <p style={styles.overviewAccentText}>
                We transform geographic data into actionable intelligence, helping organisations build smarter, more resilient, and future-ready infrastructure networks.
              </p>
              <span style={styles.overviewAccentBy}>— Inovaantage GIS Practice</span>
            </div>
          </div>
        </div>
      </section>

      <Divider />

      {/* ══ CHALLENGES ══ */}
      <section id="section-challenges" style={{ ...styles.section, background: T.surface }}>
        <div style={{ ...styles.container, padding: isMobile ? "0 16px" : "0 40px" }}>
          <SectionHeading eyebrow="Industry Pain Points" title="Challenges We Solve" />
          <div
            className="challenges-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: 24,
              marginTop: 40,
            }}
          >
            {data.challenges.map((c, i) => (
              <ChallengeCard key={i} {...c} index={i} />
            ))}
          </div>
        </div>
      </section>

      <Divider flipped />

      {/* ══ SOLUTIONS ══ */}
      <section id="section-solutions" style={{ ...styles.section, background: T.white }}>
        <div style={{ ...styles.container, padding: isMobile ? "0 16px" : "0 40px" }}>
          <SectionHeading eyebrow="Capabilities" title={`Solutions for ${data.title}`} />
          <div className="solutions-inner" style={{ maxWidth: 960, marginTop: 48 }}>
            {data.solutions.map((s, i) => (
              <SolutionCard key={s.id} solution={s} index={i} color={data.color} />
            ))}
          </div>
        </div>
      </section>

      {/* ══ WHY CHOOSE US (Telecom only) ══ */}
      {data.whyChooseUs && (
        <>
          <Divider />
          <section id="section-why" style={{ ...styles.section, background: T.surface }}>
            <div style={{ ...styles.container, padding: isMobile ? "0 16px" : "0 40px" }}>
              <SectionHeading
                eyebrow="Our Differentiators"
                title={`Why Choose Inovaantage for ${data.title}`}
                center
              />
              <div
                className="why-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: 24,
                  marginTop: 48,
                }}
              >
                {data.whyChooseUs.map((w, i) => (
                  <WhyCard key={i} {...w} index={i} />
                ))}
              </div>
            </div>
          </section>
          <Divider flipped />
        </>
      )}

      {/* ══ IMPACT & CLIENTS ══ */}
      <section
        id="section-impact"
        style={{
          ...styles.section,
          background: data.whyChooseUs ? T.white : T.surface,
          paddingBottom: 80,
        }}
      >
        <div style={{ ...styles.container, padding: isMobile ? "0 16px" : "0 40px" }}>
          <SectionHeading eyebrow="Proven Results" title="Our Impact" center />

          <div
            ref={statsRef}
            className="stats-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
              gap: 24,
              marginTop: 48,
            }}
          >
            {data.stats.map((o, i) => (
              <StatCard key={i} val={o.val} label={o.label} triggered={statsInView} />
            ))}
          </div>

          {/* Clients */}
          <div style={{ marginTop: 64 }}>
            <p style={styles.clientsEyebrow}>Trusted By</p>
            <div
              className="clients-wrap"
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 12,
                marginTop: 20,
                justifyContent: "center",
              }}
            >
              {data.clients.map((c, i) => (
                <div key={i} style={styles.clientBadge}>{c}</div>
              ))}
            </div>
          </div>

          {/* CTA strip */}
          <div style={styles.ctaStrip}>
            <div>
              <h3 style={styles.ctaTitle}>Ready to transform your {data.title.toLowerCase()} operations?</h3>
              <p style={styles.ctaSubtitle}>Speak with our {data.title} practice leads today.</p>
            </div>
            <button style={styles.ctaBtn}
              onClick={() => { if (setActivePage) { setActivePage("contact"); window.scrollTo({ top: 0, behavior: "smooth" }); } }}
              onMouseEnter={e => {
                e.currentTarget.style.background = T.orangeDeep;
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = T.orange;
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              Get in Touch →
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

// ── Styles ───────────────────────────────────────────────────────
const styles = {
  root: {
    fontFamily: "'DM Sans', system-ui, sans-serif",
    color: T.ink,
    background: T.white,
    overflowX: "hidden",
    position: "relative",
  },

  // Side nav
  sideNav: {
    position: "fixed",
    right: 28,
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 100,
    display: "flex",
    flexDirection: "column",
    gap: 4,
    background: "rgba(255,255,255,0.92)",
    backdropFilter: "blur(12px)",
    borderRadius: 12,
    padding: "16px 20px",
    border: `1px solid ${T.borderLight}`,
    boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
  },
  sideNavItem: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    fontSize: 12,
    letterSpacing: "0.04em",
    textDecoration: "none",
    padding: "5px 0",
    transition: "color 0.2s",
    fontFamily: "'DM Sans', system-ui, sans-serif",
  },
  sideNavDot: {
    width: 7,
    height: 7,
    borderRadius: "50%",
    flexShrink: 0,
    transition: "transform 0.2s, background 0.2s",
  },

  // Hero
  hero: {
    position: "relative",
    minHeight: "82vh",
    display: "flex",
    alignItems: "center",
    background: T.white,
    overflow: "hidden",
  },
  heroInner: {
    position: "relative",
    zIndex: 2,
    maxWidth: 820,
    padding: "100px 64px 80px",
  },
  heroBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    background: T.white,
    border: `1px solid ${T.border}`,
    borderRadius: 100,
    padding: "8px 18px",
    fontSize: 13,
    fontWeight: 500,
    color: T.slate,
    marginBottom: 28,
    letterSpacing: "0.02em",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  },
  heroBadgeDivider: {
    display: "inline-block",
    width: 1,
    height: 14,
    background: T.border,
    margin: "0 4px",
  },
  heroH1: {
    fontFamily: "'Syne', sans-serif",
    fontSize: "clamp(52px, 7vw, 3.5rem)",
    fontWeight: 800,
    color: T.black,
    lineHeight: 1,
    letterSpacing: "-0.03em",
    marginBottom: 24,
  },
  heroTagline: {
    fontSize: "clamp(16px, 2vw, 20px)",
    fontWeight: 300,
    color: T.slate,
    maxWidth: 600,
    lineHeight: 1.6,
    marginBottom: 32,
  },
  heroDescLine: {
    display: "flex",
    alignItems: "flex-start",
    gap: 20,
    maxWidth: 680,
  },
  heroDescAccent: {
    display: "block",
    width: 3,
    minHeight: 56,
    background: `linear-gradient(to bottom, ${T.orange}, ${T.orangeLight})`,
    borderRadius: 2,
    flexShrink: 0,
    marginTop: 3,
  },
  heroDesc: {
    fontSize: 15,
    lineHeight: 1.75,
    color: T.muted,
    margin: 0,
  },

  // Sections
  section: {
    padding: "80px 0",
    position: "relative",
  },
  container: {
    maxWidth: 1160,
    margin: "0 auto",
    padding: "0 40px",
  },

  // Section headings
  sectionHeadingWrap: {
    marginBottom: 8,
  },
  eyebrow: {
    display: "inline-block",
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    color: T.orange,
    marginBottom: 10,
  },
  sectionTitle: {
    fontFamily: "'Syne', sans-serif",
    fontSize: "clamp(28px, 3.5vw, 2rem)",
    fontWeight: 700,
    color: T.black,
    lineHeight: 1.1,
    letterSpacing: "-0.025em",
    marginBottom: 16,
  },
  headingRule: {
    width: 48,
    height: 3,
    background: `linear-gradient(to right, ${T.orange}, ${T.orangeLight})`,
    borderRadius: 2,
    marginBottom: 0,
  },

  // Overview
  overviewGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 80,
    alignItems: "center",
  },
  overviewDesc: {
    fontSize: 16,
    lineHeight: 1.8,
    color: T.slate,
    marginTop: 28,
  },
  overviewAccentBox: {
    padding: "36px 40px",
    background: T.offwhite,
    borderRadius: 16,
    border: `1px solid ${T.borderLight}`,
    position: "relative",
  },
  overviewAccentLine: {
    position: "absolute",
    top: 0,
    left: 0,
    width: 4,
    height: "100%",
    background: `linear-gradient(to bottom, ${T.orange}, ${T.orangeLight})`,
    borderRadius: "4px 0 0 4px",
  },
  overviewAccentText: {
    fontSize: 17,
    lineHeight: 1.7,
    color: T.ink,
    fontStyle: "italic",
    fontWeight: 300,
    margin: "0 0 16px",
  },
  overviewAccentBy: {
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "0.08em",
    color: T.orange,
    textTransform: "uppercase",
  },

  // Challenges
  challengeCard: {
    background: T.white,
    borderRadius: 16,
    padding: "32px 28px 28px",
    position: "relative",
    overflow: "hidden",
    cursor: "default",
    transition: "transform 0.28s ease, box-shadow 0.28s ease",
    border: `1px solid ${T.borderLight}`,
  },
  challengeIndex: {
    fontFamily: "'Syne', sans-serif",
    fontSize: 13,
    fontWeight: 700,
    color: T.orange,
    letterSpacing: "0.08em",
    marginBottom: 16,
    opacity: 0.6,
  },
  challengeIconWrap: {
    width: 48,
    height: 48,
    borderRadius: 12,
    background: T.orangePale,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 16,
  },
  challengeTitle: {
    fontFamily: "'Syne', sans-serif",
    fontSize: 17,
    fontWeight: 700,
    color: T.black,
    marginBottom: 10,
    lineHeight: 1.25,
  },
  challengeDesc: {
    fontSize: 14,
    lineHeight: 1.72,
    color: T.muted,
    margin: "0 0 20px",
  },
  challengeAccent: {
    height: 2,
    background: `linear-gradient(to right, ${T.orange}, ${T.orangeLight})`,
    borderRadius: 2,
    transition: "width 0.35s ease",
  },

  // Solutions
  solutionRow: {
    display: "flex",
    gap: 0,
    marginBottom: 28,
    alignItems: "flex-start",
  },
  solutionNumCol: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: 52,
    flexShrink: 0,
    paddingTop: 8,
  },
  solutionNumBadge: {
    width: 40,
    height: 40,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Syne', sans-serif",
    fontSize: 13,
    fontWeight: 700,
    color: T.white,
    flexShrink: 0,
    transition: "background 0.28s",
  },
  solutionNumLine: {
    width: 1,
    flex: 1,
    minHeight: 24,
    background: T.borderLight,
    marginTop: 8,
  },
  solutionCard: {
    flex: 1,
    marginLeft: 20,
    background: T.white,
    borderRadius: 16,
    border: `1px solid ${T.borderLight}`,
    padding: "28px 32px",
    transition: "box-shadow 0.28s ease",
    overflow: "hidden",
  },
  solutionHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: 16,
    marginBottom: 16,
  },
  solutionIconBox: {
    width: 52,
    height: 52,
    borderRadius: 14,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    transition: "background 0.28s",
  },
  solutionTitle: {
    fontFamily: "'Syne', sans-serif",
    fontSize: 18,
    fontWeight: 700,
    color: T.black,
    lineHeight: 1.25,
    marginBottom: 4,
  },
  solutionSubtitle: {
    fontSize: 13,
    fontWeight: 500,
    color: T.orange,
    letterSpacing: "0.02em",
    margin: 0,
  },
  solutionDesc: {
    fontSize: 14,
    lineHeight: 1.8,
    color: T.slate,
    marginBottom: 20,
  },
  featuresGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "10px 24px",
    marginBottom: 20,
  },
  featureItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
  },
  featureDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    background: T.orange,
    marginTop: 7,
    flexShrink: 0,
  },
  featureTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: T.ink,
  },
  featureDesc: {
    fontSize: 13,
    color: T.muted,
    lineHeight: 1.6,
  },
  impactBanner: {
    background: `linear-gradient(135deg, ${T.orangePale}, #FFF9F4)`,
    borderRadius: 10,
    padding: "14px 18px",
    borderLeft: `3px solid ${T.orange}`,
  },
  impactLabel: {
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: T.orange,
    display: "block",
    marginBottom: 4,
  },
  impactText: {
    fontSize: 13,
    color: T.ink,
    lineHeight: 1.7,
    margin: 0,
    fontWeight: 400,
  },

  // Why choose us
  whyCard: {
    background: T.white,
    borderRadius: 16,
    padding: "32px 28px",
    textAlign: "center",
    border: `1px solid ${T.borderLight}`,
    cursor: "default",
    transition: "transform 0.28s ease, box-shadow 0.28s ease",
  },
  whyIconBox: {
    width: 64,
    height: 64,
    borderRadius: 18,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 20px",
    transition: "background 0.28s",
  },
  whyTitle: {
    fontFamily: "'Syne', sans-serif",
    fontSize: 16,
    fontWeight: 700,
    color: T.black,
    marginBottom: 8,
  },
  whyDesc: {
    fontSize: 13,
    lineHeight: 1.7,
    color: T.muted,
    margin: 0,
  },

  // Stats
  statCard: {
    background: T.white,
    borderRadius: 16,
    padding: "36px 28px",
    textAlign: "center",
    border: `1px solid ${T.borderLight}`,
    position: "relative",
    overflow: "hidden",
  },
  statVal: {
    display: "block",
    fontFamily: "'Syne', sans-serif",
    fontSize: "clamp(32px, 2vw, 48px)",
    fontWeight: 800,
    color: T.orange,
    lineHeight: 1,
    marginBottom: 10,
    letterSpacing: "-0.02em",
  },
  statLabel: {
    display: "block",
    fontSize: 13,
    fontWeight: 500,
    color: T.muted,
    letterSpacing: "0.02em",
    lineHeight: 1.4,
  },

  // Clients
  clientsEyebrow: {
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.14em",
    textTransform: "uppercase",
    color: T.muted,
    textAlign: "center",
    margin: 0,
  },
  clientBadge: {
    padding: "10px 22px",
    borderRadius: 8,
    border: `1px solid ${T.border}`,
    background: T.white,
    fontSize: 13,
    fontWeight: 600,
    color: T.slate,
    letterSpacing: "0.02em",
    whiteSpace: "nowrap",
    transition: "border-color 0.2s, color 0.2s",
  },

  // CTA
  ctaStrip: {
    marginTop: 72,
    background: T.black,
    borderRadius: 20,
    padding: "48px 56px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 40,
    flexWrap: "wrap",
    position: "relative",
    overflow: "hidden",
  },
  ctaTitle: {
    fontFamily: "'Syne', sans-serif",
    fontSize: "clamp(20px, 2.5vw, 28px)",
    fontWeight: 700,
    color: T.white,
    marginBottom: 8,
    lineHeight: 1.2,
  },
  ctaSubtitle: {
    fontSize: 15,
    color: "rgba(255,255,255,0.55)",
    margin: 0,
    fontWeight: 300,
  },
  ctaBtn: {
    padding: "16px 36px",
    background: T.orange,
    color: T.white,
    border: "none",
    borderRadius: 10,
    fontSize: 15,
    fontWeight: 600,
    cursor: "pointer",
    letterSpacing: "0.02em",
    transition: "background 0.22s, transform 0.22s",
    whiteSpace: "nowrap",
    fontFamily: "'DM Sans', system-ui, sans-serif",
  },
};
